<template>
    <div>
        <button type="button" :class="btn_class" @click="show_modal">
            <i class="fa" :class="icon_class" v-if="show_icon"></i>
            {{ label }}
        </button>

        <div class="modal fade" ref="modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">
                            {{ label }}
                            <span v-if="total_samples > 1">
                                ({{ applying_to }})
                            </span>
                        </h4>
                    </div>
                    <div class="modal-body container-fluid">
                        <div class="modal-subheader text-bold">
                            <i class="fa fa-info-circle modal-subheader-icon"></i>
                            <span>Any recommendations not present on our official report should be reviewed by an agricultural specialist prior to application.</span>
                        </div>
                        <div class="p-25">
                            <div class="row m-b-25">
                                <div class="col-xs-4 text-bold text-center">Crop</div>
                                <div class="col-xs-4 text-bold text-center">Yield Goal</div>
                                <div class="col-xs-4 text-bold text-center">Previous Crop</div>
                            </div>
                            <div class="row" v-for="(rec, index) in recs_requested" style="height:60px">
                                <div class="col-xs-4">
                                    <select class="form-control" v-model="rec.crop" @change="crop_changed(index)">
                                        <option :value="empty_rec"></option>
                                        <option v-for="crop in current_crops" :value="crop">
                                            {{ crop.name + (crop.unit ? ' - ' + crop.unit : '') }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-xs-4 p-r-30">
                                    <vue-slider class="m-r-5"
                                        v-model="rec.yield"
                                        :min="rec.crop.min_yield"
                                        :max="rec.crop.max_yield"
                                        :disabled="!rec.crop.id"
                                        :interval="rec.crop.yield_increment"
                                        tooltipDir="right"
                                    ></vue-slider>
                                </div>

                                <div class="col-xs-4">
                                    <select class="form-control" v-model="rec.previous">
                                        <option :value="empty_rec"></option>
                                        <option v-for="crop in available_crops" :value="crop">
                                            {{ crop.name + (crop.unit ? ' - ' + crop.unit : '') }}
                                        </option>
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal">
                            <span class="fa fa-times"></span>
                            Close
                        </button>
                        <button type="button" class="btn btn-lg btn-primary" :disabled="incomplete_rec_requests.length > 0"  v-if="rec_type == 'report'" @click="calculate_recs">
                            <span class="fa fa-check"></span>
                            Calculate
                        </button>
                        <button type="button" class="btn btn-lg btn-primary" :disabled="incomplete_rec_requests.length > 0"  v-else-if="rec_type == 'order'" @click="update_recs">
                            <span class="fa fa-check"></span>
                            Done
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .flexbox {
        display: flex;
        flex-direction: row;

        .flex {
            flex: 1;
        }
    }
</style>
<script type="text/ecmascript-6">
    import vueSlider from 'vue-slider-component';

    export default{
        props: {
            btn_class: { default: 'btn btn-primary' },
            show_icon: { default: true },
            icon_class: { default: 'fa-calculator' },
            label: { default: 'Alter Recommendations' },
            samples: { default() { return [] }},
            max_recs: { default: 3 },
            selected_recs: { default() { return [] }},
            total_samples: { default: 1 },
            available_crops: { default() { return [] }},
            rec_type: { default: 'report' }
        },
        components: {
            vueSlider
        },
        data () {
            return {
                modal: null,
                empty_crop: {
                    id: null,
                    name: null,
                    min_yield: 0,
                    max_yield: 100,
                    average_yield: null
                },
                recs_requested: []
            }
        },
        computed: {
            empty_rec () {
                return {
                    crop: this.empty_crop,
                    yield: 0,
                    previous: this.empty_crop
                }
            },
            incomplete_rec_requests () {
                return this.recs_requested.filter(rec => rec.crop.id || rec.yield || rec.previous.id)
                    .filter(rec => !rec.crop.id || !rec.yield || !rec.previous.id);
            },
            applying_to () {
                if (this.samples.length == 1) {
                    return this.samples[0].client_id;
                }

                return 'all samples';
            },
            recs_to_calc () {
                return this.recs_requested.filter(rec => rec.crop.id).map(rec => {
                    return {
                        crop_id: rec.crop.id,
                        previous_crop_id: rec.previous.id,
                        yield: rec.yield
                    }
                })
            },
            current_crops() {
                return this.available_crops.filter(crop => crop.only_prev_crop === 0);
            },
        },
        watch: {
            samples () {
                this.set_recs
            }
        },
        methods: {
            show_modal () {
                this.modal.modal('show');
                this.$emit('shown');
            },
            set_recs () {
                let sample0 = this.samples.length > 0 ? this.samples[0] : {};

                this.recs_requested = [];

                _.range(this.max_recs).forEach(i => {
                    let rec = this.empty_rec;

                    if (_.has(sample0, ['recs',i])) {
                        rec =  {
                            crop: this.available_crops.find(crop => crop.id == sample0.recs[i].crop.id),
                            yield: parseInt(sample0.recs[i].yield),
                            previous: this.available_crops.find(crop => crop.id == sample0.recs[i].previous.id)
                        }
                    }
                    else if (_.has(this.selected_recs, i)) {
                        rec =  {
                            crop: this.available_crops.find(crop => crop.id == this.selected_recs[i].crop_id),
                            yield: parseInt(this.selected_recs[i].yield),
                            previous: this.available_crops.find(crop => crop.id ==  this.selected_recs[i].previous_crop_id)
                        }
                    }

                    this.recs_requested.push(_.clone(rec));
                })
            },
            crop_changed (index) {
                let rec = this.recs_requested[index];
                rec.yield = _.has(rec,['crop','average_yield']) ? rec.crop.average_yield : 0;
            },
            update_recs () {
                this.$emit('update_recs', this.recs_to_calc);
                this.modal.modal('hide');
            },
            calculate_recs () {
                this.$http.post('/soils/recommendations',{
                    sample_ids: this.samples.map(sample => { return sample.id }),
                    recs: this.recs_to_calc
                })
                    .then(response => {
                        if (response.data) {
                            let recs = response.data.map(sample => {
                                return {
                                    id: sample.labnum,
                                    recs: sample.recommendations.map(rec => {
                                        return {
                                            crop: this.available_crops.find(crop => crop.id == rec.parameters.crop_id),
                                            previous: this.available_crops.find(crop => crop.id == rec.parameters.previous_crop_id),
                                            yield: rec.parameters.yield,
                                            b: rec.results.b || 0,
                                            cu: rec.results.cu || 0,
                                            elesulf: rec.results.elesulf || 0,
                                            fe: rec.results.fe || 0,
                                            gyptons: rec.results.gyptons || 0,
                                            k2o: rec.results.k2o || 0,
                                            limepounds: rec.results.limepounds || 0,
                                            limetons: rec.results.limetons || 0,
                                            mg: rec.results.mg || 0,
                                            mn: rec.results.mn || 0,
                                            n: rec.results.n || 0,
                                            p2o5: rec.results.p2o5 || 0,
                                            s: rec.results.s || 0,
                                            zn: rec.results.zn || 0,
                                            crop_removals: rec.crop_removals || {}
                                        }
                                    })
                                }
                            });

                            this.$emit('recs_calculated', recs);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });

                this.modal.modal('hide');
            }
        },
        mounted () {
            this.modal = $(this.$refs.modal)
            this.modal.on('shown.bs.modal', this.set_recs);
        }
    }
</script>



// WEBPACK FOOTER //
// soil-recs-modal.vue?7638f5ea